(() => {
  document.querySelectorAll('[data-change-requests-page]').forEach(async (page) => {
    const privateSession = window.NubsSessionState.privateScope(page);
    const fetch = (...args) => privateSession.fetch(...args);
    const bridge = (page.dataset.bridgeUrl || 'https://members.nubsmedia.ca').replace(/\/$/, '');
    const loading = page.querySelector('[data-change-requests-loading]');
    const errorBox = page.querySelector('[data-change-requests-error]');
    const signin = page.querySelector('[data-change-requests-signin]');
    const list = page.querySelector('[data-change-requests-list]');
    const submitted = page.querySelector('[data-change-requests-submitted]');

    const requestId = new URLSearchParams(window.location.search).get('submitted');
    if (requestId && submitted) {
      submitted.textContent = `Change request ${requestId} was submitted successfully. Thank you for helping improve the database!`;
      submitted.hidden = false;
    }

    const makeText = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      node.textContent = text;
      return node;
    };

    const releaseUrl = (request) => {
      const title = String(request?.releaseTitle || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      const number = String(request?.releaseCatalogId || '').replace(/^NMREL-/i, '').trim();
      return title && /^\d+$/.test(number) ? `/community/release/${encodeURIComponent(title)}-nmrel-${encodeURIComponent(number)}` : '';
    };

    try {
      const response = await fetch(`${bridge}/bridge/change-request?mode=list`, {
        credentials: 'include',
      });
      const body = await response.json().catch(() => null);

      if (response.status === 401) {
        loading.hidden = true;
        signin.hidden = false;
        return;
      }
      if (!response.ok) {
        throw new Error(body?.error || `Request failed (${response.status}).`);
      }

      loading.hidden = true;
      list.hidden = false;
      list.innerHTML = '';

      if (!body.requests?.length) {
        const empty = makeText('div', 'nubs-change-requests__empty', 'You have not submitted any database change requests yet.');
        list.appendChild(empty);
        return;
      }

      body.requests.forEach((request) => {
        const card = document.createElement('article');
        card.className = 'nubs-change-requests__card';

        const top = document.createElement('div');
        top.className = 'nubs-change-requests__card-top';
        const titleWrap = document.createElement('div');
        const heading = makeText('h2', '', '');
        const href = releaseUrl(request);
        if (href) {
          const link = makeText('a', 'nubs-change-requests__release-link', request.releaseTitle || request.releaseCatalogId || 'Database release');
          link.href = href;
          heading.appendChild(link);
        } else {
          heading.textContent = request.releaseTitle || request.releaseCatalogId || 'Database release';
        }
        titleWrap.appendChild(heading);
        const displayDate = request.appliedAt || request.reviewedAt || request.submittedAt;
        const when = displayDate ? new Date(displayDate).toLocaleString([], {dateStyle: 'medium', timeStyle: 'short'}) : 'Unknown time';
        titleWrap.appendChild(
          makeText(
            'p',
            'nubs-change-requests__meta',
            `${request.requestId} · ${request.releaseCatalogId} · ${when}`,
          ),
        );

        const contributor = request.contributorUsername || 'Community member';
        const changeCount = Number(request.changeCount) || (request.changes?.fields || []).length;
        titleWrap.appendChild(
          makeText(
            'p',
            'nubs-change-requests__meta nubs-change-requests__meta--secondary',
            request.status === 'approved'
              ? `${changeCount} approved contribution${changeCount === 1 ? '' : 's'} · credited to ${contributor}`
              : `Submitted by ${contributor} · ${changeCount} proposed change${changeCount === 1 ? '' : 's'}`,
          ),
        );

        const status = String(request.status || 'pending').toLowerCase();
        const statusLabels = {
          pending: 'Pending review',
          approved: 'Approved',
          rejected: 'Not approved',
          changes_requested: 'More information needed',
        };
        const statusPill = makeText(
          'span',
          `nubs-change-requests__status-pill nubs-change-requests__status-pill--${status.replace(/[^a-z0-9_-]/g, '-')}`,
          statusLabels[status] || request.status || 'Pending review',
        );
        top.append(titleWrap, statusPill);
        card.appendChild(top);

        const fields = request.changes?.fields || [];
        if (fields.length) {
          const changes = document.createElement('div');
          changes.className = 'nubs-change-requests__changes';
          fields.forEach((change) => {
            const block = document.createElement('div');
            block.className = 'nubs-change-requests__change';
            block.appendChild(makeText('strong', '', change.label || change.fieldKey));
            const compare = document.createElement('div');
            compare.className = 'nubs-change-requests__comparison';
            const oldSide = document.createElement('div');
            oldSide.append(makeText('span', 'nubs-change-requests__value-label', request.status === 'approved' ? 'Before' : 'Current'), makeText('div', 'nubs-change-requests__value', change.oldValue || '—'));
            const newSide = document.createElement('div');
            newSide.append(makeText('span', 'nubs-change-requests__value-label', request.status === 'approved' ? 'Approved' : 'Proposed'), makeText('div', 'nubs-change-requests__value', change.newValue || '—'));
            compare.append(oldSide, newSide);
            block.appendChild(compare);
            changes.appendChild(block);
          });
          card.appendChild(changes);
        }

        const imageInfo = request.changes?.images;
        if (imageInfo && ((imageInfo.remove || []).length || (imageInfo.add || []).length)) {
          card.appendChild(makeText(
            'div',
            'nubs-change-requests__images',
            `Images: ${(imageInfo.add || []).length} addition(s), ${(imageInfo.remove || []).length} removal request(s).`,
          ));
        }

        if (request.note && request.status !== 'approved') {
          const note = document.createElement('div');
          note.className = 'nubs-change-requests__note';
          note.append(makeText('strong', '', 'Notes'), makeText('div', 'nubs-change-requests__value', request.note));
          card.appendChild(note);
        }

        if (request.reviewNote && request.status === 'rejected') {
          const review = document.createElement('div');
          review.className = 'nubs-change-requests__note';
          review.append(makeText('strong', '', 'Review note'), makeText('div', 'nubs-change-requests__value', request.reviewNote));
          card.appendChild(review);
        }

        if (request.status === 'rejected') {
          card.appendChild(makeText('p', 'nubs-change-requests__retention-note', 'Declined requests remain visible here for about 30 days, then are automatically removed.'));
        }

        list.appendChild(card);
      });

      window.NubsListPagination?.attach(list, {
        itemSelector: ':scope > .nubs-change-requests__card',
        pageSize: 20,
        queryParam: 'change_page',
        label: 'Change request pages',
      });
    } catch (error) {
      loading.hidden = true;
      errorBox.textContent = error.message || 'Unable to load your change requests.';
      errorBox.hidden = false;
    }
  });
})();
